import * as React from 'react';
import ReactSelect from 'react-select';
import classnames from 'classnames';

import Button from '@components/Button';
import Checkbox from '@components/Checkbox';

import 'react-select/dist/react-select.css';
import './style.scss';

interface IFilterProps {
  name: string;
  value: any;
  options: IPickListOptions[];
  onChange: TButtonOnClick;
  onBlur?: TButtonOnClick;
  onFocus?: TButtonOnClick;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  handler?: JSX.Element;
}

interface IFilterState {
  selectedValueIndices: boolean[];
  selectAll: boolean;
}

export default class Filter extends React.Component<IFilterProps, IFilterState> {
  public static defaultProps: IFilterProps = {
    name: '',
    value: '',
    onChange: null,
    placeholder: 'Select Option',
    options: null,
    disabled: false,
    handler: null,
  };

  constructor(props: IFilterProps) {
    super(props);

    this.state = {
      selectedValueIndices: [],
      selectAll: false,
    };
  }

  componentDidMount() {
    this.setState(this.getStateFromProps(this.props));
  }

  componentWillReceiveProps(nextProps: IFilterProps) {
    if (nextProps.value !== this.props.value) {
      this.setState(this.getStateFromProps(nextProps));
    }
  }

  getStateFromProps = (nextProps: IFilterProps): IFilterState => {
    const { options, value } = nextProps;
    let selectAll = true;

    const selectedValueIndices = options.map((option) => {
      const isSelected = value.findIndex((v) => v === option.value) !== -1;

      selectAll = selectAll && isSelected;

      return isSelected;
    });

    return {
      selectedValueIndices,
      selectAll,
    };
  };

  onChange = () => {
    const { options } = this.props;

    const newValue = this.state.selectedValueIndices.reduce((accumulator, isValueSelected, index) => {
      if (isValueSelected) {
        accumulator.push(options[index].value);
      }

      return accumulator;
    }, []);
    this.props.onChange({
      target: { name: this.props.name, value: newValue },
      currentTarget: { name: this.props.name, value: newValue },
    });
  };

  resetState = () => {
    this.setState(this.getStateFromProps(this.props));
  };

  onOptionChecked = (optionIndex: number) => (e: React.SyntheticEvent<HTMLInputElement>) => {
    const isSelected = e.currentTarget.checked;
    const prevSelectedValueIndices = this.state.selectedValueIndices;
    const selectedValueIndices = [
      ...prevSelectedValueIndices.slice(0, optionIndex),
      isSelected,
      ...prevSelectedValueIndices.slice(optionIndex + 1),
    ];
    const selectAll = selectedValueIndices.findIndex((isIndexChecked) => !isIndexChecked) === -1;

    this.setState((prevState) => ({
      selectedValueIndices,
      selectAll,
    }));
  };

  onSelectAllToggle = (e: React.SyntheticEvent<HTMLInputElement>) => {
    const selectAll = e.currentTarget.checked;
    const selectedValueIndices = this.state.selectedValueIndices.map((selectedValueIndex) => selectAll);

    this.setState({
      selectAll,
      selectedValueIndices,
    });
  };

  renderOption = (option: IPickListOptions, optionIndex: number) => (
    <div key={option.value} className={classnames('select__menu__option')}>
      <Checkbox
        name="option"
        onChange={this.onOptionChecked(optionIndex)}
        isChecked={this.state.selectedValueIndices[optionIndex]}
      >
        {option.label}
      </Checkbox>
    </div>
  );

  renderMenu = (props) => {
    const { handler } = this.props;

    return (
      <div className={classnames('select__menu')}>
        <div className={classnames('select__menu__body')}>
          <div className={classnames('select__menu__title', 'flex-row--center', 'flex--spaced')}>
            <Checkbox name="all" onChange={this.onSelectAllToggle} isChecked={this.state.selectAll}>
              All
            </Checkbox>
            {handler && handler}
          </div>
          {props.options && (
            <div className={classnames('select__menu__options')}>
              {props.options.map((option, index) => this.renderOption(option, index))}
            </div>
          )}
        </div>
        <div className={classnames('select__menu__actions', 'flex-row--middle')}>
          <Button bsStyle={ButtonStyle.DEFAULT} onClick={this.resetState}>
            Cancel
          </Button>
          <Button bsStyle={ButtonStyle.PRIMARY} onClick={this.onChange} className={classnames('space-left')}>
            Apply
          </Button>
        </div>
      </div>
    );
  };

  render() {
    const { name, options, disabled, value, placeholder } = this.props;

    return (
      <ReactSelect
        className={classnames('select')}
        value={value}
        name={name}
        menuRenderer={this.renderMenu}
        options={options}
        clearable={false}
        placeholder={placeholder}
        disabled={disabled}
        onClose={this.resetState}
        onFocus={this.props.onFocus}
        searchable={false}
        multi={true}
        removeSelected={false}
        closeOnSelect={false}
      />
    );
  }
}
